import React from 'react';

import createEmotionCache from 'app/create-emotion-cache';

import App from './components/main';
import BaseProviders from './providers/base';
import ClientProviders from './providers/client';
import { initI18n } from './utils/init-i18n';
import { initQueryClient } from './utils/init-query-client';
import { initSentry } from './utils/init-sentry';
import { initStores } from './utils/init-stores';
import { initTheme } from './utils/inti-theme';
import { render } from './utils/render';

import 'assets/css/main.css';
import 'assets/css/light.css';
import 'assets/css/monokai_sublime.css';

const ssr = window.__SSR__;
const config = window.__CONFIG__;
const dehydratedState = window._____APP_STATE_____;
const reactQueryState = window.__REACT_QUERY_STATE__;

initI18n();
initSentry(config);

const cache = createEmotionCache();
const theme = initTheme(config);
const stores = initStores(dehydratedState);
const queryClient = initQueryClient();

function Component() {
    return (
        <BaseProviders cache={cache} theme={theme} config={config} stores={stores} queryClient={queryClient}>
            <ClientProviders queryState={reactQueryState}>
                <App />
            </ClientProviders>
        </BaseProviders>
    );
}

render({ id: 'body', ssr, component: <Component /> });
